import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyReservedSearch, reservedPath } from "../../features/marketplace/navigation";

export const Route = createFileRoute("/_authed/marketplace")({
  validateSearch: legacyReservedSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ href: search.request ? "/reserved-compute/request" : reservedPath(search.view), replace: true });
  },
});
